import classNames from "classnames";
import Styles from "./About.module.scss";
import Navbar from "../../Component/Navbar/Navbar";
import Jumbotron from "../../Component/Jumbotron/Jumbotron";
import Footer from "../../Component/Footer/Footer";

import joinus from "../../assets/images/index/關於我們.jpg";
import SubTitle from "../../Component/Text/SubTitle";
import { ScrollRestoration } from 'react-router-dom';
import CountUp from 'react-countup';
import { useInView } from "framer-motion";
import React from "react";

const AboutUs = () => {
  const ref = React.useRef(null)
  const isInView = useInView(ref, { once: true });
  return (
    <div>
      <Navbar />
      <div style={{ paddingTop: "8vh" }}>
        <Jumbotron img={joinus} text={`關於我們`} />
      </div>

      {/* ABOUT US */}
      <div>
        <SubTitle text={"ABOUT US"} />
        <div
          className={classNames("container", "p-3", Styles.about__description)}
        >
          廣博長照發展協會是以非營利為目的的公益性社會團體，以「
          <span className={Styles.about__blod}>
            尊嚴老化、自主專業弱勢、讓照顧人才回流
          </span>
          」為宗旨。期望結合社會資源，拓展社區照顧交流平台、提昇長照的品質。
        </div>
      </div>

      {/* Our Duty */}
      <div className={classNames(Styles.about__ours)}>
        <div className={classNames("container", Styles.about__ours__card)}>
          <div className={classNames("col-sm-12", "col-md-12", "col-lg-6",)}>
            <div className={classNames("container", Styles.about__ours__card__content)}>
              <h6 className={classNames(Styles.about__ours__card__title)}>
                我們的願景
              </h6>
              <div className={classNames(Styles.about__ours__card__param)}>
                在地服務、在地老化、在地人幫在地人一起走長遠的美麗安居晚景。
              </div>
            </div>
          </div>
          <div className={classNames("col-sm-12", "col-md-12", "col-lg-6",)}>
            <div>
              <h6 className={classNames(Styles.about__ours__card__title)}>
                我們的使命
              </h6>
              <div className={classNames(Styles.about__ours__card__param)}>
                老有所終，壯有所用，長者及身心障礙者皆有所養。滋養在地人就業，服務年長者終老。
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ServiceCount */}
      <div className={classNames(Styles.about__service)}>
        <SubTitle text={`服務人數`} />
        <div className={classNames("container")}>
          <div
            ref={ref}
            className={classNames(Styles.about__service__card)}>
            <div
              className={classNames(
                "col-lg-6",
                "col-md-12",
                "col-sm-12",
                "mb-3",
              )}
            >
              <div>
                <div className={classNames(Styles.about__service__card__title)}>
                  身心障礙者居家式
                  <br />
                  臨時短期照顧服務
                </div>
                <div
                  className={classNames(Styles.about__service__card__content)}
                >
                  <p
                    className={classNames(
                      Styles.about__service__card__content__num
                    )}
                  >
                    {isInView ? (
                      <CountUp start={0} end={1377} duration={2} separator="," />
                    ) : (
                      0
                    )}
                  </p>
                  <p
                    className={classNames(
                      Styles.about__service__card__content__unit
                    )}
                  >
                    人
                  </p>
                </div>
                <div className={classNames(Styles.about__service__card__param)}>
                  花蓮市、秀林鄉、吉安鄉、壽豐鄉、光復鄉、玉里鎮
                </div>
              </div>
            </div>
            <div
              className={classNames(
                "col-lg-6",
                "col-md-12",
                "col-sm-12",
                "mb-3",
              )}
            >
              <div>
                <div className={classNames(Styles.about__service__card__title)}>
                  長期照顧巴士接送
                </div>
                <div
                  className={classNames(Styles.about__service__card__content)}
                >
                  <p
                    className={classNames(
                      Styles.about__service__card__content__num
                    )}
                  >
                    {isInView ? (
                      <CountUp start={0} end={3535} duration={2} separator="," />
                    ) : 0}
                  </p>
                  <p
                    className={classNames(
                      Styles.about__service__card__content__unit
                    )}
                  >
                    次
                  </p>
                </div>
                <div className={classNames(Styles.about__service__card__param)}>
                  花蓮市、新城鄉、秀林鄉、吉安鄉、壽豐鄉、
                  <br />
                  瑞穗鄉、富里鄉、玉里鎮、卓溪鄉
                </div>
              </div>
            </div>
          </div>
          <div className={classNames(
            Styles.about__service__card
          )}>
            <div
              className={classNames(
                "col-lg-6",
                "col-md-12",
                "col-sm-12",
                "mb-3",
              )}
            >
              <div>
                <div className={classNames(Styles.about__service__card__title)}>
                  長照居家困境物資發放
                </div>
                <div
                  className={classNames(Styles.about__service__card__content)}
                >
                  <p
                    className={classNames(
                      Styles.about__service__card__content__num
                    )}
                  >
                    {isInView ? (
                      <CountUp start={0} end={41} duration={2} separator="," />
                    ) : 0}

                  </p>
                  <p
                    className={classNames(
                      Styles.about__service__card__content__unit
                    )}
                  >
                    人
                  </p>
                </div>
              </div>
            </div>
            <div className={classNames("col-6")}></div>
          </div>
          <div >
            <p className={classNames(Styles.about__service__card__param)}>資料來源：112年廣博長照慈善協會</p>
          </div>
        </div>
      </div>

      {/*Description */}
      <div>
        <div
          className={classNames("container", "p-3", Styles.about__description)}
        >
          目前博廣服務的個案包含
          <br />
          花蓮市、秀林、吉安、光復、瑞穗、玉里、富里等地。
          <br />
          花蓮北起和平鄉，南至富里鄉全長約160公里是一個地形長的大縣，
          因此服務的範圍也偏佈廣大的地區。
          <br />
          花蓮因居民的經濟條件及交通便利性並不像都會區一樣富足。
          <br />
          因此，在人力和服務的安排上需比其他縣市來較多的費心。
          <br />
          即使如此，我們的服務仍秉持在地人幫助在地人的熱忱。
          <br />
          ”為長者的美麗晚景，也為自己的未來老化後的美好”
        </div>
        <div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
